import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAppStore = create(
  persist(
    (set) => ({
      nightMode: true,
      toggleNightMode: () => set((s) => ({ nightMode: !s.nightMode })),
      setNightMode: (value) => set({ nightMode: value }),
    }),
    {
      name: 'braingrid-app',
      partialize: (state) => ({ nightMode: state.nightMode }),
    }
  )
);
